import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Grid, Stack } from '@mui/material';
import { useForm } from 'react-hook-form';
import { CVHttpService } from '../../services';

function ExperienceFormDialog({ open, onClose, onSave, cvId, experience }) {
    const { register, handleSubmit, formState: { errors }, reset } = useForm({
        defaultValues: experience || {
            title: '',
            company_title: '',
            description: '',
            start_date: '',
            end_date: ''
        }
    });

    const toDateInput = (dateStr) => {
        if (!dateStr) return '';
        return new Date(dateStr).toISOString().split('T')[0];
    };

    React.useEffect(() => {
        if (experience) {
            reset({
                ...experience,
                start_date: toDateInput(experience.start_date),
                end_date: toDateInput(experience.end_date),
            });
        } else {
            reset({
                title: '',
                company_title: '',
                description: '',
                start_date: '',
                end_date: ''
            });
        }
    }, [experience, reset]);

    const formatDateForAPI = (dateStr) => {
        if (!dateStr) return null;
        return `${dateStr}T00:00:00Z`;
    };

    const onSubmit = async (data) => {
        try {
            const body = {
                ...data,
                start_date: formatDateForAPI(data.start_date),
                end_date: formatDateForAPI(data.end_date),
                id: experience?.id || null,
                cv: cvId,
                user: null
            };
            await CVHttpService.saveJobExperience(body);
            onSave();
        } catch (err) {
            alert('Failed to save experience');
        }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <form onSubmit={handleSubmit(onSubmit)}>
                <DialogTitle>{experience ? 'Edit Experience' : 'Add Experience'}</DialogTitle>
                <DialogContent>
                    <Stack spacing={3} sx={{ mt: 1 }}>
                        <TextField
                            fullWidth
                            label="Job Title *"
                            {...register('title', { required: 'Job title is required' })}
                            error={!!errors.title}
                            helperText={errors.title?.message}
                        />
                        <TextField
                            fullWidth
                            label="Company Name *"
                            {...register('company_title', { required: 'Company name is required' })}
                            error={!!errors.company_title}
                            helperText={errors.company_title?.message}
                        />
                        <TextField
                            fullWidth
                            label="Description"
                            multiline
                            rows={2}
                            {...register('description')}
                        />
                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <TextField
                                    fullWidth
                                    label="Start Date"
                                    type="date"
                                    {...register('start_date')}
                                    InputLabelProps={{ shrink: true }}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    fullWidth
                                    label="End Date"
                                    type="date"
                                    {...register('end_date')}
                                    InputLabelProps={{ shrink: true }}
                                />
                            </Grid>
                        </Grid>
                    </Stack>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose}>Cancel</Button>
                    <Button type="submit" variant="contained">Save</Button>
                </DialogActions>
            </form>
        </Dialog>
    );
}

export default ExperienceFormDialog;

